import React, { useState, useEffect } from "react";

// 顶部定义getVideoFrame，供所有组件使用
const getVideoFrame = async (videoFile, timeStr) => {
  let time = 0;
  let valid = true;

  // 支持多种时间格式，优先取区间起始点
  if (/^第(\d+)帧/.test(timeStr)) {
    const frameNum = parseInt(timeStr.match(/^第(\d+)帧/)[1]);
    time = frameNum * 0.033;
  } else if (/^第(\d+)帧至第(\d+)帧/.test(timeStr)) {
    const frameNum = parseInt(timeStr.match(/^第(\d+)帧至第(\d+)帧/)[1]);
    time = frameNum * 0.033;
  } else if (/^第(\d+)[-~至](\d+)帧/.test(timeStr)) {
    const frameNum = parseInt(timeStr.match(/^第(\d+)[-~至](\d+)帧/)[1]);
    time = frameNum * 0.033;
  } else if (/^第(\d+)秒/.test(timeStr)) {
    const sec = parseInt(timeStr.match(/^第(\d+)秒/)[1]);
    time = sec;
  } else if (/^第(\d+)[-~至](\d+)秒/.test(timeStr)) {
    const sec = parseInt(timeStr.match(/^第(\d+)[-~至](\d+)秒/)[1]);
    time = sec;
  } else if (/^(\d+):(\d+)[-~至](\d+):(\d+)/.test(timeStr)) {
    // 0:15-0:25
    const match = timeStr.match(/^(\d+):(\d+)[-~至](\d+):(\d+)/);
    const min = parseInt(match[1]);
    const sec = parseInt(match[2]);
    time = min * 60 + sec;
  } else if (/^(\d+):(\d+)/.test(timeStr)) {
    // 0:15
    const [min, sec] = timeStr.split(':').map(Number);
    time = min * 60 + sec;
  } else if (/^(\d+)[-~至](\d+)$/.test(timeStr)) {
    // 3-6
    const sec = parseInt(timeStr.match(/^(\d+)[-~至](\d+)$/)[1]);
    time = sec;
  } else if (/^\d+$/.test(timeStr)) {
    time = parseInt(timeStr);
  } else {
    valid = false;
  }

  if (!valid) return null;

  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'auto';
    video.src = URL.createObjectURL(videoFile);

    video.onloadedmetadata = () => {
      if (time > video.duration) time = Math.max(0, video.duration - 0.1);
      video.currentTime = time;
    };

    video.onseeked = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/png'));
      URL.revokeObjectURL(video.src);
    };

    video.onerror = () => resolve(null);
  });
};

const presetRules = [
  {
    name: "站房检查规则",
    content: [
      "配备监控",
      "所有的气瓶需要整齐靠墙摆放并被固定（如铁链、卡扣）",
      "规章制度公示牌需要整齐贴在墙上",
      "检测参数表需要贴在墙上"
    ]
  }
];

const AiInspection = () => {
  const [uploadType, setUploadType] = useState("image"); // image or video
  const [selectedPreset, setSelectedPreset] = useState(Object.keys(presetRules)[0] || '');
  const [images, setImages] = useState([]);
  const [video, setVideo] = useState(null);
  const [ruleType, setRuleType] = useState("preset"); // preset or custom
  const [selectedRule, setSelectedRule] = useState(presetRules[0].name);
  const [customRule, setCustomRule] = useState("");
  const [aiResult, setAiResult] = useState(null);
  const [debugInfo, setDebugInfo] = useState("");

  // 步骤状态
  const [steps, setSteps] = useState([
    { label: '上传文件', status: 'pending' },
    { label: '上传成功', status: 'pending' },
    { label: 'AI分析中', status: 'pending' },
    { label: '分析完成', status: 'pending' },
  ]);

  // Dify API配置
  const API_KEY = 'app-QYYTBQJxIN9M9YcBclZWTUfN';
  const API_UPLOAD_URL = 'https://ai.avon.live/v1/files/upload';
  const API_WORKFLOW_URL = 'https://ai.avon.live/v1/workflows/run';
  const USER_ID = 'test-user'; // 可根据实际登录用户动态生成

  // 辅助：文件转base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  // 生成AI提示词
  const buildPrompt = (rule, type) => {
    if (type === 'image') {
      return `请根据以下检查规则，分析上传的所有照片：\n${rule}\n【要求】\n1. 对照每一条规范检查是否符合，在照片具体什么位置出现上述要素，返回对应坐标（如有）；\n2. 如果不符合，给出对应的要求；\n3. 如果照片中未出现，提示需要补充拍摄的内容。\n【输出格式】\n每条规范：合格/不合格，配图（图片序号）、坐标、AI建议。`;
    } else {
      return `请根据以下检查规则，分析上传的视频：\n${rule}\n【要求】\n1. 对照每一条规范检查是否符合，在视频具体什么位置（第几帧）出现上述要素，返回对应帧号和坐标（如有）；\n2. 如果不符合，给出对应的要求；\n3. 如果视频中未出现，提示需要补充拍摄的内容。\n【输出格式】\n每条规范：合格/不合格，帧号、坐标、AI建议。`;
    }
  };

  // 上传图片
  const handleImageUpload = (e) => {
    setImages(Array.from(e.target.files));
    setVideo(null);
  };

  // 上传视频
  const handleVideoUpload = (e) => {
    setVideo(e.target.files[0]);
    setImages([]);
  };

  // 修改handleFileChange，限制图片数量最多5张
  const handleFileChange = (e) => {
    if (uploadType === 'image') {
      const files = Array.from(e.target.files);
      if (files.length > 5) {
        alert('最多只能上传5张图片');
        return;
      }
      setImages(files);
    } else {
      setVideo(e.target.files[0]);
    }
  };

  // 上传图片并获取upload_file_id
  const uploadImageAndGetId = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user', USER_ID);
    const res = await fetch(API_UPLOAD_URL, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${API_KEY}` },
      body: formData
    });
    const data = await res.json();
    return data.id;
  };

  // 规则内容
  const getRuleContent = () => {
    if (ruleType === "preset") {
      return presetRules.find(r => r.name === selectedRule)?.content.join("；") || "";
    }
    return customRule;
  };

  // AI调用
  const handleAICheck = async () => {
    setAiResult(null);
    setDebugInfo("");
    setSteps([
      { label: '上传文件', status: 'in_progress' },
      { label: '上传成功', status: 'pending' },
      { label: 'AI分析中', status: 'pending' },
      { label: '分析完成', status: 'pending' },
    ]);
    try {
      let upload_file_ids = [];
      let fileInfo = null;
      
      if (uploadType === 'image' && images.length > 0) {
        setSteps(s => s.map((step, i) => i === 0 ? { ...step, status: 'completed' } : step));
        
        // 上传所有图片，获取upload_file_id数组
        for (let i = 0; i < images.length; i++) {
          const upload_file_id = await uploadImageAndGetId(images[i]);
          upload_file_ids.push(upload_file_id);
          setDebugInfo(prev => prev + `图片${i + 1}文件名: ${images[i].name}\n类型: ${images[i].type}\nupload_file_id: ${upload_file_id}\n`);
        }
        
        setSteps(s => s.map((step, i) => i === 1 ? { ...step, status: 'completed' } : step));
        setDebugInfo(prev => prev + `\n总共上传了 ${images.length} 张图片\n`);
        
      } else if (uploadType === 'video' && video) {
        fileInfo = video;
        setSteps(s => s.map((step, i) => i === 0 ? { ...step, status: 'completed' } : step));
        const upload_file_id = await uploadImageAndGetId(video);
        upload_file_ids.push(upload_file_id);
        setSteps(s => s.map((step, i) => i === 1 ? { ...step, status: 'completed' } : step));
        setDebugInfo(prev => prev + `视频文件名: ${fileInfo.name}\n类型: ${fileInfo.type}\nupload_file_id: ${upload_file_id}\n`);
      } else {
        setDebugInfo('请上传图片或视频');
        return;
      }
      
      setSteps(s => s.map((step, i) => i === 2 ? { ...step, status: 'in_progress' } : step));
      
      // 构造workflow请求体时，区分图片和视频
      let workflowBody = null;
      if (uploadType === 'video') {
        // 视频保持原有逻辑
        workflowBody = {
          inputs: {
            videos: {
              transfer_method: 'local_file',
              upload_file_id: upload_file_ids[0],
              type: 'video'
            }
          },
          response_mode: 'blocking',
          user: USER_ID
        };
      } else {
        // 图片使用images数组，支持多张图片
        workflowBody = {
          inputs: {
            images: upload_file_ids.map(upload_file_id => ({
              transfer_method: 'local_file',
              upload_file_id,
              type: 'image'
            }))
          },
          response_mode: 'blocking',
          user: USER_ID
        };
      }
      
      setDebugInfo(prev => prev + `\nworkflowBody: ${JSON.stringify(workflowBody, null, 2)}\n`);
      const headers = {
        'Authorization': `Bearer ${API_KEY}`,
        'Content-Type': 'application/json'
      };
      setDebugInfo(prev => prev + `\nworkflow headers: ${JSON.stringify(headers)}\n`);
      const response = await fetch(API_WORKFLOW_URL, {
        method: 'POST',
        headers,
        body: JSON.stringify(workflowBody)
      });
      setDebugInfo(prev => prev + `\nworkflow status: ${response.status} ${response.statusText}\n`);
      const data = await response.json();
      setDebugInfo(prev => prev + `\nworkflow response: ${JSON.stringify(data, null, 2)}\n`);
      setSteps(s => s.map((step, i) => i === 2 ? { ...step, status: 'completed' } : step));
      setSteps(s => s.map((step, i) => i === 3 ? { ...step, status: 'completed' } : step));
      setAiResult(data.data);
    } catch (err) {
      setDebugInfo(prev => prev + '\nAI调用失败: ' + (err.stack || err.message));
      setSteps(s => s.map((step, i) => i === 2 ? { ...step, status: 'failed' } : step));
      setSteps(s => s.map((step, i) => i === 3 ? { ...step, status: 'failed' } : step));
    }
  };

  // 解析AI返回的outputs.text字段中的JSON，提取“站房类型”和“检查结果”数组
  let checkArray = [];
  let stationType = '';
  let rawText = aiResult?.outputs?.text || aiResult?.outputs || '';
  if (rawText) {
    let match = rawText.match(/```json[\s\S]*?([\[{].*[\]}])[\s\S]*?```/);
    let jsonStr = '';
    if (match && match[1]) {
      jsonStr = match[1].trim();
    } else {
      jsonStr = rawText.replace(/^```json\s*/, '').replace(/```[\s\S]*$/, '').trim();
    }
    try {
      const parsed = JSON.parse(jsonStr);
      if (Array.isArray(parsed.检查结果)) {
        checkArray = parsed.检查结果;
      }
      if (parsed.站房类型) {
        stationType = parsed.站房类型;
      }
    } catch (e) {}
  }

  // 放大图片预览弹窗
  const [previewImg, setPreviewImg] = useState(null);

  // 响应式样式
  const containerStyle = {
    maxWidth: 700,
    margin: '32px auto',
    background: '#f8fbff',
    borderRadius: 20,
    padding: 24,
    boxShadow: '0 2px 12px #e5e9f2',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  };
  const formStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'center',
  };
  const labelStyle = { minWidth: 72, fontWeight: 500, marginRight: 8 };
  const inputStyle = { minWidth: 120, flex: 1, borderRadius: 8, border: '1px solid #e3e8ee', padding: '6px 12px', fontSize: 16 };
  const buttonStyle = { background: '#1976d2', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 32px', fontSize: 18, fontWeight: 500, cursor: 'pointer', boxShadow: '0 2px 8px #d3adf7', width: '100%', maxWidth: 220 };
  const resultCardStyle = { border: '1px solid #e3e8ee', borderRadius: 12, marginBottom: 20, padding: 16, background: '#fff', boxShadow: '0 1px 4px #e5e9f2' };

  // 媒体查询适配手机端
  const mobileStyle = `
  @media (max-width: 600px) {
    .ai-inspection-container { padding: 0 2vw !important; max-width: 100vw !important; }
    .ai-inspection-form { flex-direction: column !important; gap: 10px !important; }
    .ai-inspection-form label { min-width: 0 !important; margin-right: 0 !important; font-size: 15px !important; }
    .ai-inspection-form input, .ai-inspection-form select { min-width: 0 !important; width: 100% !important; font-size: 15px !important; }
    .ai-inspection-btn { width: 100% !important; max-width: none !important; font-size: 17px !important; }
    .ai-inspection-result-card { flex-direction: column !important; align-items: flex-start !important; padding: 10px !important; }
    .ai-inspection-result-card img { width: 100% !important; height: auto !important; max-width: 90vw !important; margin-left: 0 !important; margin-top: 8px !important; }
    .ai-inspection-result-card > div { width: 100% !important; }
    .ai-inspection-result-card span, .ai-inspection-result-card div { font-size: 15px !important; word-break: break-all; }
    .ai-inspection-result-card .result-main { width: 100% !important; }
    .ai-inspection-result-card .result-img { width: 100% !important; min-width: 0 !important; margin-left: 0 !important; padding-right: 0 !important; }
    textarea { font-size: 14px !important; }
    h2, h3 { font-size: 20px !important; }
  }
  `;

  // 步骤条渲染
  const stepColor = status => status === 'completed' ? '#52c41a' : status === 'in_progress' ? '#1976d2' : status === 'failed' ? '#ff4d4f' : '#d9d9d9';

  // 在组件顶部添加：根据照片序号获取对应图片的辅助函数
  const getImageByIndex = (photoIndex, images) => {
    if (!photoIndex || !images || images.length === 0) return null;
    
    // 解析照片序号，如"第1张"、"第3张"等
    const match = photoIndex.match(/第(\d+)张/);
    if (!match) return null;
    
    const index = parseInt(match[1]) - 1; // 转换为0基索引
    if (index >= 0 && index < images.length) {
      return images[index];
    }
    return null;
  };

  // 新增：图片预览组件
  function ImagePreview({ imageFile, photoIndex, onClick, clickable }) {
    const [previewUrl, setPreviewUrl] = useState(null);

    useEffect(() => {
      if (imageFile) {
        const url = URL.createObjectURL(imageFile);
        setPreviewUrl(url);
        return () => URL.revokeObjectURL(url);
      }
    }, [imageFile]);

    if (!previewUrl) return <span style={{ color: '#aaa', fontSize: 12 }}>加载中...</span>;

    return (
      <img
        src={previewUrl}
        alt={`照片${photoIndex}`}
        style={{ 
          width: 80, 
          height: 48, 
          objectFit: 'cover', 
          borderRadius: 6, 
          marginLeft: 8, 
          cursor: clickable ? 'pointer' : 'default', 
          border: clickable ? '2px solid #1976d2' : undefined 
        }}
        onClick={clickable ? () => onClick && onClick(previewUrl) : undefined}
      />
    );
  }

  return (
    <div>
      <style>{mobileStyle}</style>
      <div className="ai-inspection-container" style={containerStyle}>
        {/* 步骤条 */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 24, gap: 12 }}>
          {steps.map((step, idx) => (
            <React.Fragment key={step.label}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ width: 18, height: 18, borderRadius: '50%', background: stepColor(step.status), color: '#fff', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>{idx + 1}</div>
                <div style={{ fontSize: 12, color: stepColor(step.status), marginTop: 4 }}>{step.label}</div>
              </div>
              {idx < steps.length - 1 && <div style={{ width: 32, height: 2, background: stepColor(steps[idx + 1].status), margin: '0 2px' }} />}
            </React.Fragment>
          ))}
        </div>
        <h2 style={{ textAlign: 'center', color: '#1976d2', fontWeight: 700, marginBottom: 24 }}>站房AI巡检</h2>
        <form className="ai-inspection-form" style={formStyle} onSubmit={e => { e.preventDefault(); handleAICheck(); }}>
          <label style={labelStyle}>上传类型：</label>
          <select style={inputStyle} value={uploadType} onChange={e => setUploadType(e.target.value)}>
            <option value="image">照片</option>
            <option value="video">视频</option>
          </select>
          <input 
            style={inputStyle} 
            type="file" 
            accept={uploadType === 'image' ? 'image/*' : 'video/*'} 
            multiple={uploadType === 'image'} // 图片支持多选，视频单选
            onChange={handleFileChange} 
          />
          {uploadType === 'image' && images.length > 0 && (
            <div style={{ fontSize: 12, color: '#1976d2', marginTop: 4 }}>
              已选择 {images.length} 张图片（最多同时上传5张）
            </div>
          )}
          <label style={labelStyle}>检查规则：</label>
          <select style={inputStyle} value={selectedRule} onChange={e => setSelectedRule(e.target.value)}>
            <option value="preset">站房检查规则</option>
            <option value="custom">自定义</option>
          </select>
          {selectedRule === 'preset' && (
            <select style={inputStyle} value={selectedPreset} onChange={e => setSelectedPreset(e.target.value)}>
              {Object.keys(presetRules).map(key => (
                <option key={key} value={key}>{presetRules[key].name}</option>
              ))}
            </select>
          )}
          <button className="ai-inspection-btn" style={buttonStyle} type="submit">提交AI检查</button>
        </form>
        {/* 结构化AI结果展示 */}
        {checkArray.length > 0 && (
          <div style={{ margin: '24px 0', background: '#f6faff', borderRadius: 16, padding: 16 }}>
            <h3 style={{ color: '#1976d2', marginBottom: 16 }}>AI巡检结果</h3>
            {stationType && <div style={{ fontWeight: 600, fontSize: 18, color: '#1976d2', marginBottom: 16 }}>站房类型：{stationType}</div>}
            {checkArray.map((item, idx) => (
              <div className="ai-inspection-result-card" style={{...resultCardStyle, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexDirection: 'row', flexWrap: 'wrap'}} key={idx}>
                <div className="result-main" style={{flex: 1, minWidth: 0}}>
                  <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>
                    <span style={{ display: 'inline-block', background: '#1976d2', color: '#fff', borderRadius: '50%', width: 28, height: 28, textAlign: 'center', lineHeight: '28px', fontSize: 16, marginRight: 12 }}>{idx + 1}</span>
                    {item.规范项 || item.规范要求 || '-'}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ color: item.检查结果 === '符合' ? '#52c41a' : item.检查结果 === '不符合' ? '#ff4d4f' : '#faad14', fontWeight: 500, marginRight: 16 }}>
                      检查结果：{item.检查结果 || '-'}
                    </span>
                    <span style={{ color: '#888', marginRight: 16 }}>
                      {uploadType === 'image' && item.检查结果 !== '图片未涉及' ? '照片序号：' : uploadType === 'video' ? '视频时间位置：' : ''}
                      {(() => {
                        if (uploadType === 'image') {
                          return item.照片序号 || '-';
                        } else {
                          const pos = item.视频时间位置 || '-';
                          if (/^\d+$/.test(pos)) return `第${pos}帧`;
                          if (/^第?\d+帧$/.test(pos)) return pos.replace(/^第?/, '第');
                          if (/^\d+帧$/.test(pos)) return `第${pos.replace('帧', '')}帧`;
                          return pos;
                        }
                      })()}
                    </span>
                  </div>
                  {/* 备注/规范要求/整改要求/下一步确认优先展示，保持美观 */}
                  {item.备注 && <div style={{ marginBottom: 4 }}><b>备注：</b>{item.备注}</div>}
                  {item.规范要求 && <div style={{ marginBottom: 4 }}><b>规范要求：</b>{item.规范要求}</div>}
                  {item.整改要求 && <div style={{ marginBottom: 4 }}><b>整改要求：</b>{item.整改要求}</div>}
                  {item.下一步确认 && <div style={{ marginBottom: 4 }}><b>下一步确认：</b>{item.下一步确认}</div>}
                </div>
                {/* 根据上传类型显示不同的预览 */}
                {uploadType === 'image' && item.照片序号 && (
                  <div className="result-img" style={{ minWidth: 90, marginLeft: 16, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', paddingRight: 16 }}>
                    <div style={{ fontSize: 10, color: '#666', marginBottom: 4 }}>
                      照片: {item.照片序号}<br/>
                      序号: {item.照片序号}
                    </div>
                    <ImagePreview 
                      imageFile={getImageByIndex(item.照片序号, images)} 
                      photoIndex={item.照片序号}
                      onClick={img => setPreviewImg(img)} 
                      clickable={true} 
                    />
                  </div>
                )}
                {uploadType === 'video' && video && item.视频时间位置 && (
                  <div className="result-img" style={{ minWidth: 90, marginLeft: 16, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', paddingRight: 16 }}>
                    <div style={{ fontSize: 10, color: '#666', marginBottom: 4 }}>
                      视频: {video.name}<br/>
                      时间: {item.视频时间位置}
                    </div>
                    <AsyncVideoFrame videoFile={video} timeStr={item.视频时间位置} onClick={img => setPreviewImg(img)} clickable />
                  </div>
                )}
              </div>
            ))}
            {/* 图片预览弹窗 */}
            {previewImg && (
              <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setPreviewImg(null)}>
                <img src={previewImg} alt="预览" style={{ maxWidth: '90vw', maxHeight: '90vh', borderRadius: 12, boxShadow: '0 4px 24px #0008' }} />
              </div>
            )}
          </div>
        )}
        {/* 重新显示调试区 */}
        <div style={{ marginTop: 16 }}>
          <div style={{ color: '#888', fontWeight: 600, marginBottom: 4 }}>工作流</div>
          <textarea style={{ width: '100%', minHeight: 60, borderRadius: 8, border: '1px solid #e3e8ee', fontSize: 14, padding: 8 }} value={debugInfo} readOnly />
        </div>
      </div>
    </div>
  );
};

// 修改AsyncVideoFrame组件，支持onClick和clickable，增强调试信息
function AsyncVideoFrame({ videoFile, timeStr, onClick, clickable }) {
  const [img, setImg] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setImg(null); setError(null);
    if (videoFile && timeStr) {
      getVideoFrame(videoFile, timeStr)
        .then(result => {
          if (result === null) {
            setImg('NO_SCREENSHOT');
          } else {
            setImg(result);
          }
        })
        .catch(err => {
          setError(err.message);
        });
    }
  }, [videoFile, timeStr]);

  if (error) return <span style={{ color: 'red', fontSize: 12 }}>截图失败: {error}</span>;
  if (img === null) return <span style={{ color: '#aaa', fontSize: 12 }}>截图中...</span>;
  if (img === 'NO_SCREENSHOT') return <span style={{ color: '#aaa', fontSize: 12, border: '1px dashed #1976d2', borderRadius: 6, padding: 8 }}>无截图</span>;

  return (
    <img
      src={img}
      alt="视频截图"
      style={{ width: 80, height: 48, objectFit: 'cover', borderRadius: 6, marginLeft: 8, cursor: clickable ? 'pointer' : 'default', border: clickable ? '2px solid #1976d2' : undefined }}
      onClick={clickable ? () => onClick && onClick(img) : undefined}
    />
  );
}

export default AiInspection; 